angular.module('sempraWebapp').factory('AppStateService', function () {
  var state = {};

  return {
    getState: function () {
      return state;
    },
    setState: function (key, value) {
      state[key] = value;
    },
    clearState: function () {
      state = {};
    }
  };
});
